export class MathUtils {
  static angle(cx: number, cy: number, ex: number, ey: number): number {
    let dy = ey - cy;
    let dx = ex - cx;
    let theta = Math.atan2(dy, dx); // range (-PI, PI]
    theta = MathUtils.radiansToDegrees(theta); // rads to degs, range (-180, 180]
    if (theta < 0) theta = 360 + theta; // range [0, 360)
    return theta;
  }

  static radiansToDegrees(radians: number) {
    return radians * (180 / Math.PI);
  }

  static degreesToRadians(degrees: number) {
    return degrees * (Math.PI / 180);
  }

  static normalizeAngle(angle: number) {
    if (angle >= 360 || angle <= -360) {
      let aux = angle / 360;
      aux = Math.floor(aux);
      aux *= 360;
      angle -= aux;
    }

    if (angle < 0) {
      angle = 360 + angle;
    }

    return angle;
  }

  static invertAngle(angle: number) {
    angle -= 180;
    angle = MathUtils.normalizeAngle(angle);
    return angle;
  }

  static moveByAngle(
    angle: number,
    cx: number,
    cy: number,
    value: number
  ): { x: number; y: number } {
    angle = MathUtils.normalizeAngle(angle);
    const radians = MathUtils.degreesToRadians(angle);

    const xIncrement = Math.cos(radians) * value;
    const yIncrement = Math.sin(radians) * value;

    const x = cx + xIncrement;
    const y = cy + yIncrement;

    return { x, y };
  }

  static positivize(value: number) {
    return value < 0 ? -value : value === 0 ? 0 : value;
  }

  static negativize(value: number) {
    return value > 0 ? -value : value === 0 ? 0 : value;
  }
}
